export const pickedServiceKeys = [
    'Client',
    'Day',
    'ID',
    'PlaceStart',
    'PlaceStop',
    'Roster',
    'RosterClient',
    'ServiceType',
    'Start',
    'Stop',
];
//# sourceMappingURL=types-client-portal.js.map